import React, { useEffect, useState } from 'react';
import { getMarkDetails } from '../utils/marks';

const MarkToast = ({ markId, onDismiss }) => {
  const [phase, setPhase] = useState('entering');

  useEffect(() => {
    if (!markId) return;
    setPhase('entering');
    const showTimer = setTimeout(() => setPhase('visible'), 50);
    const exitTimer = setTimeout(() => setPhase('exiting'), 4200);
    const dismissTimer = setTimeout(onDismiss, 4700);
    return () => {
      clearTimeout(showTimer);
      clearTimeout(exitTimer);
      clearTimeout(dismissTimer);
    };
  }, [markId, onDismiss]);

  if (!markId) return null;
  const mark = getMarkDetails(markId);
  if (!mark) return null;

  return (
    <div
      className={`mark-toast mark-toast-${phase}`}
      role="status"
      aria-live="polite"
    >
      <div className="mark-toast-line">
        <span className="mark-toast-prefix">Marked.</span>
        <span className="mark-toast-name">{mark.name}.</span>
      </div>
      <div className="mark-toast-desc">{mark.description}</div>
    </div>
  );
};

export default MarkToast;
